import baseAPI from "@/api/base";
import { EditTag, GetTag, RegisterTag } from "@/dtos/Tag.dto";
import {
  DELETE_TAG_URL,
  EDIT_TAG_URL,
  GET_TAG_URL,
  REGISTER_TAG_URL,
  TOGGLE_TAG_IS_ACTIVE_URL,
} from "@/utils/urls";
import { AxiosResponse } from "axios";

class Tag {
  static getTags = async (getTag: GetTag): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GET_TAG_URL, {
      params: getTag,
    });
    return response;
  };

  static registerTag = async (registerTag: RegisterTag): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.post(REGISTER_TAG_URL, {
      ...registerTag,
    });
    return response;
  };

  static editTag = async (editTag: EditTag): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.put(EDIT_TAG_URL, {
      ...editTag,
    });
    return response;
  };

  static toggleTagIsActive = async (editTag: EditTag): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.patch(TOGGLE_TAG_IS_ACTIVE_URL, {
      ...editTag,
    });
    return response;
  };

  static deleteTag = async (id: string): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.delete(`${DELETE_TAG_URL}/${id}`);
    return response;
  };
}

export default Tag;
